import PropTypes from 'prop-types';

const CustomTick = (props) => {
  const {
    x, y, payload, chartData, dataKey, hoveredCategory,
  } = props;

  const { value } = payload;
  const { subTitle } = chartData.find((d) => d[dataKey] === value) || {};
  const isHovered = hoveredCategory === value;
  const modifiedTitle = subTitle ? `${value} - ${subTitle}` : value;

  return (
    <g transform={`translate(${x},${y}) rotate(-45)`}>
      <text
        textAnchor="end"
        x={0}
        y={0}
        dy={5}
        fontSize={12}
        fill={isHovered ? '#253A71' : '#6D6D6D'}
        fontWeight={isHovered ? 'bold' : 'normal'}
      >
        {modifiedTitle}
      </text>
    </g>
  );
};

CustomTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  chartData: PropTypes.array,
  payload: PropTypes.object,
  dataKey: PropTypes.string,
  hoveredCategory: PropTypes.string,
};

export default CustomTick;
